"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _utils = require("@dsc/utils");
var _WalletContext = require("./hooks/WalletContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // packages/ui/HeaderToken.js
// --------------------------------------------------
//  Header ONLY for AoToken and ApToken apps
//  • Requires react-router-dom
//  • Requires WalletContext (ethers)
//  • Platform SHOULD NOT import this file
// --------------------------------------------------

var HeaderToken = function HeaderToken(_ref) {
  var _ref$appType = _ref.appType,
    appType = _ref$appType === void 0 ? "aotoken" : _ref$appType;
  // Wallet provided by context (AoToken / ApToken)
  var wallet = (0, _react.useContext)(_WalletContext.WalletContext) || {};
  var address = wallet.address,
    connectWallet = wallet.connectWallet,
    disconnectWallet = wallet.disconnectWallet,
    connecting = wallet.connecting,
    error = wallet.error;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    openDropdown = _useState2[0],
    setOpenDropdown = _useState2[1];

  // Router location
  var location = {
    pathname: ""
  };
  try {
    location = (0, _reactRouterDom.useLocation)();
  } catch (e) {
    location = {
      pathname: ""
    };
  }
  var toggleDropdown = function toggleDropdown(label) {
    return setOpenDropdown(function (prev) {
      return prev === label ? null : label;
    });
  };

  // ----------------------------
  // AoToken vs ApToken menus
  // ----------------------------
  var menus = appType === "aotoken" ? [{
    label: "Authorisation Programs",
    to: "/aotoken-collection"
  }, {
    label: "Issue Licence",
    dropdown: [{
      label: "Manage Signers",
      to: "/manage-multisig"
    }, {
      label: "Propose Licence",
      to: "/propose-token-mint"
    }]
  }, {
    label: "Approve Licence",
    to: "/approve-mint-request"
  }, {
    label: "My Licences",
    to: "/load-aotoken"
  }] : [{
    label: "Provenance Program",
    to: "/program"
  }, {
    label: "Create Product Passport",
    to: "/mint-ap-token"
  }, {
    label: "My Product Passports",
    to: "/tokens?next=details"
  }, {
    label: "Provenance Logs",
    dropdown: [{
      label: "Record Provenance",
      to: "/record-event"
    }, {
      label: "View Provenance",
      to: "/tokens?next=events"
    }]
  }];

  // Log wallet info (debugging)
  (0, _react.useEffect)(function () {
    if (address) console.log("Wallet address loaded:", address);
  }, [address]);
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: "header"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-left"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://dscnextgen.com",
    target: "_blank",
    rel: "noreferrer",
    className: "header-brand"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: "/logo_dscn.png",
    alt: "DSC NextGen Logo",
    className: "header-logo"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "header-title"
  }, "DSC NextGen"))), /*#__PURE__*/_react["default"].createElement("nav", {
    className: "header-nav"
  }, menus.map(function (m) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: m.label,
      className: "header-menu-item"
    }, m.to ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: m.to,
      className: "header-link",
      style: {
        color: location.pathname === m.to ? "#5b21b6" : "#000"
      }
    }, m.label) : /*#__PURE__*/_react["default"].createElement("button", {
      onClick: function onClick() {
        return toggleDropdown(m.label);
      },
      className: "header-dropdown-btn",
      style: {
        color: openDropdown === m.label ? "#5b21b6" : "#000"
      }
    }, m.label, " ", /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        fontSize: "0.8em"
      }
    }, "\u25BC")), m.dropdown && openDropdown === m.label && /*#__PURE__*/_react["default"].createElement("div", {
      className: "header-dropdown"
    }, m.dropdown.map(function (sub) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        key: sub.to,
        to: sub.to,
        onClick: function onClick() {
          return setOpenDropdown(null);
        },
        className: "header-dropdown-item"
      }, sub.label);
    })));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-auth"
  }, address ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-wallet-box"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "header-addr"
  }, (0, _utils.shortAddress)(address)), /*#__PURE__*/_react["default"].createElement("button", {
    className: "header-btn-secondary",
    onClick: disconnectWallet
  }, "Disconnect")) : /*#__PURE__*/_react["default"].createElement("button", {
    className: "header-btn-primary",
    onClick: connectWallet,
    disabled: connecting
  }, connecting ? "Connecting..." : "Auth Login")), error && /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-error"
  }, error));
};
var _default = exports["default"] = HeaderToken;